/* ClicScent — main.js v3.1
   Mobile-first · Keyboard accessible · Focus trap · Sticky ATC */
(function(){
'use strict';

/* ── Utils ──────────────────────────────────────────────────── */
var qs  = function(s,p){return(p||document).querySelector(s);};
var qsa = function(s,p){return(p||document).querySelectorAll(s);};
var money = function(cents){
  return new Intl.NumberFormat('en-EU',{style:'currency',currency:'EUR',minimumFractionDigits:2}).format(cents/100);
};
var esc = function(s){
  return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
};

/* ── Focus trap for dialogs (cart drawer, mobile nav) ──────── */
function trapFocus(el){
  var focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var nodes = Array.from(el.querySelectorAll(focusable)).filter(function(n){return n.offsetParent !== null;});
  if(!nodes.length) return;
  var first = nodes[0];
  var last  = nodes[nodes.length - 1];
  function handler(e){
    if(e.key !== 'Tab') return;
    if(e.shiftKey){
      if(document.activeElement === first){ e.preventDefault(); last.focus(); }
    } else {
      if(document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  }
  el._trapHandler = handler;
  el.addEventListener('keydown', handler);
  first.focus();
}
function releaseFocus(el, returnEl){
  if(el._trapHandler) el.removeEventListener('keydown', el._trapHandler);
  if(returnEl && typeof returnEl.focus === 'function') returnEl.focus();
}

/* ── Cart ───────────────────────────────────────────────────── */
var _cartOpener = null; // element that opened cart, for focus return

function openCart(triggerEl){
  _cartOpener = triggerEl || document.activeElement;
  var overlay = qs('#cart-overlay');
  var drawer  = qs('#cart-drawer');
  overlay.classList.add('open');
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden','false');
  overlay.setAttribute('aria-hidden','false');
  document.body.style.overflow = 'hidden';
  refreshCart();
  trapFocus(drawer);
  // announce to screen readers
  var live = qs('#cart-live') || document.createElement('div');
  live.id = 'cart-live';
  live.setAttribute('role','status');
  live.setAttribute('aria-live','polite');
  live.className = 'sr-only';
  document.body.appendChild(live);
}
function closeCart(){
  var overlay = qs('#cart-overlay');
  var drawer  = qs('#cart-drawer');
  overlay.classList.remove('open');
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden','true');
  overlay.setAttribute('aria-hidden','true');
  document.body.style.overflow = '';
  releaseFocus(drawer, _cartOpener);
}

function refreshCart(){
  fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(console.error);
}

function renderCart(cart){
  /* update badges */
  qsa('.cart-count-badge').forEach(function(el){
    el.textContent = cart.item_count;
    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    el.setAttribute('aria-label', cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '') + ' in cart');
  });
  var countEl = qs('#cd-count');
  if(countEl) countEl.textContent = '(' + cart.item_count + ')';
  var totEl = qs('#cd-total');
  if(totEl) totEl.textContent = money(cart.total_price);
  var foot = qs('#cart-foot');
  if(foot) foot.style.display = cart.item_count > 0 ? 'block' : 'none';

  var body = qs('#cart-body');
  if(!body) return;

  if(cart.item_count === 0){
    body.innerHTML = [
      '<div class="cd-empty">',
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" width="44" height="44">',
          '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>',
          '<line x1="3" y1="6" x2="21" y2="6"/>',
          '<path d="M16 10a4 4 0 0 1-8 0"/>',
        '</svg>',
        '<p>Your cart is empty</p>',
        '<a href="/collections/all" class="btn-fill sm" style="margin-top:1rem;">Shop fragrances</a>',
      '</div>'
    ].join('');
    return;
  }

  var html = '';
  cart.items.forEach(function(item){
    html += '<div class="cd-item">' +
      '<div class="cd-img">' + (item.image ? '<img src="' + item.image + '" alt="' + esc(item.title) + '" loading="lazy" width="64" height="64">' : '') + '</div>' +
      '<div class="cd-info">' +
        '<p class="cd-vendor">' + esc(item.vendor) + '</p>' +
        '<p class="cd-title">' + esc(item.product_title) + '</p>' +
        (item.variant_title !== 'Default Title' ? '<p style="font-size:10px;color:var(--muted);">' + esc(item.variant_title) + '</p>' : '') +
        '<p class="cd-price">' + money(item.final_line_price) + '</p>' +
        '<button class="cd-remove" data-key="' + item.key + '" aria-label="Remove ' + esc(item.product_title) + ' from cart">Remove</button>' +
      '</div>' +
      '</div>';
  });
  body.innerHTML = html;

  qsa('.cd-remove', body).forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.disabled = true;
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:btn.dataset.key, quantity:0})
      }).then(function(r){return r.json();}).then(renderCart);
    });
  });
}

function addToCart(id, qty, btn){
  var origText = btn ? btn.textContent : '';
  var origLabel = btn ? btn.getAttribute('aria-label') : '';
  if(btn){ btn.disabled = true; btn.textContent = 'Adding…'; btn.setAttribute('aria-label','Adding to cart'); }

  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:id, quantity:qty||1})
  })
  .then(function(r){return r.json();})
  .then(function(){return fetch('/cart.js');})
  .then(function(r){return r.json();})
  .then(function(cart){
    renderCart(cart);
    openCart(btn);
    if(btn){
      btn.textContent = 'Added ✓';
      btn.setAttribute('aria-label','Added to cart');
      btn.classList.add('added');
      setTimeout(function(){
        btn.textContent = origText;
        btn.setAttribute('aria-label', origLabel);
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2200);
    }
  })
  .catch(function(err){
    console.error(err);
    if(btn){ btn.textContent = origText; btn.setAttribute('aria-label',origLabel); btn.disabled = false; }
  });
}

/* ── Accordion (ARIA-compliant) ─────────────────────────────── */
function initAccordions(){
  qsa('.acc-btn').forEach(function(btn){
    // Set initial aria
    btn.setAttribute('aria-expanded','false');
    var body = btn.nextElementSibling;
    if(body) body.setAttribute('hidden','');

    btn.addEventListener('click',function(){
      var isOpen = btn.classList.contains('open');
      var parent = btn.closest('.accordion');
      if(parent){
        qsa('.acc-btn',parent).forEach(function(b){
          b.classList.remove('open');
          b.setAttribute('aria-expanded','false');
          var bd = b.nextElementSibling;
          if(bd){ bd.classList.remove('open'); bd.setAttribute('hidden',''); }
        });
      }
      if(!isOpen){
        btn.classList.add('open');
        btn.setAttribute('aria-expanded','true');
        if(body){ body.classList.add('open'); body.removeAttribute('hidden'); }
      }
    });

    // Keyboard: Space/Enter already fires click on button; add arrow key support
    btn.addEventListener('keydown',function(e){
      var parent = btn.closest('.accordion');
      if(!parent) return;
      var btns = Array.from(qsa('.acc-btn',parent));
      var idx  = btns.indexOf(btn);
      if(e.key === 'ArrowDown'){ e.preventDefault(); if(btns[idx+1]) btns[idx+1].focus(); }
      if(e.key === 'ArrowUp')  { e.preventDefault(); if(btns[idx-1]) btns[idx-1].focus(); }
      if(e.key === 'Home')     { e.preventDefault(); btns[0].focus(); }
      if(e.key === 'End')      { e.preventDefault(); btns[btns.length-1].focus(); }
    });
  });
}

/* ── Gallery thumbs ─────────────────────────────────────────── */
function initGallery(){
  var mainImg = qs('#gallery-main-img');
  qsa('.gallery-thumb').forEach(function(thumb, i){
    thumb.setAttribute('tabindex','0');
    thumb.setAttribute('role','button');

    function activate(){
      if(mainImg && thumb.dataset.src){
        mainImg.src = thumb.dataset.src;
        // Update alt text from thumb
        var thumbImg = thumb.querySelector('img');
        if(thumbImg) mainImg.alt = thumbImg.alt;
      }
      qsa('.gallery-thumb').forEach(function(t){ t.classList.remove('on'); t.setAttribute('aria-pressed','false'); });
      thumb.classList.add('on');
      thumb.setAttribute('aria-pressed','true');
    }

    thumb.addEventListener('click', activate);
    thumb.addEventListener('keydown',function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); activate(); }
    });
    // Initial
    thumb.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
  });
}

/* ── Variant selector ───────────────────────────────────────── */
function initVariants(){
  qsa('.var-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var grid = btn.closest('.var-grid');
      if(grid) qsa('.var-btn',grid).forEach(function(b){
        b.classList.remove('on');
        b.setAttribute('aria-pressed','false');
      });
      btn.classList.add('on');
      btn.setAttribute('aria-pressed','true');

      // Update hidden input
      var form = qs('.js-atc-form');
      if(form){ var inp = qs('[name="id"]',form); if(inp) inp.value = btn.dataset.variant; }

      // Update price display
      var priceEl = qs('#js-price');
      if(priceEl && btn.dataset.price){
        priceEl.textContent = money(parseInt(btn.dataset.price, 10));
      }

      // Update sticky ATC price
      var stickyPrice = qs('.sticky-atc-price');
      if(stickyPrice && btn.dataset.price){
        stickyPrice.textContent = money(parseInt(btn.dataset.price, 10));
      }

      // Update sticky ATC variant ID
      var stickyBtn = qs('.sticky-atc-btn');
      if(stickyBtn) stickyBtn.dataset.variant = btn.dataset.variant;
    });

    // Arrow key navigation in variant grid
    btn.addEventListener('keydown',function(e){
      var grid = btn.closest('.var-grid');
      if(!grid) return;
      var btns = Array.from(qsa('.var-btn:not([disabled])',grid));
      var idx  = btns.indexOf(btn);
      if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){ e.preventDefault(); if(btns[idx+1]) btns[idx+1].focus(); }
      if(e.key === 'ArrowLeft'  || e.key === 'ArrowUp')  { e.preventDefault(); if(btns[idx-1]) btns[idx-1].focus(); }
    });
  });
}

/* ── ATC form submit ────────────────────────────────────────── */
function initForms(){
  document.addEventListener('submit',function(e){
    var form = e.target;
    if(!form.classList.contains('js-atc-form')) return;
    e.preventDefault();
    var inp = qs('[name="id"]',form);
    var btn = qs('[type="submit"]',form);
    if(inp) addToCart(inp.value, 1, btn);
  });
}

/* ── Quick add (product cards) ──────────────────────────────── */
function initQuickAdd(){
  document.addEventListener('click',function(e){
    var btn = e.target.closest('.js-add');
    if(!btn) return;
    addToCart(btn.dataset.variant, 1, btn);
  });
}

/* ── Mobile nav ─────────────────────────────────────────────── */
function initMobileNav(){
  var openBtn  = qs('#mobile-open');
  var closeBtn = qs('#mobile-close');
  var nav      = qs('#mobile-nav');
  if(!nav) return;

  function open(){
    nav.classList.add('open');
    nav.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    trapFocus(nav);
  }
  function close(){
    nav.classList.remove('open');
    nav.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    releaseFocus(nav, openBtn);
  }

  if(openBtn)  openBtn.addEventListener('click', open);
  if(closeBtn) closeBtn.addEventListener('click', close);

  // Close on Escape
  nav.addEventListener('keydown',function(e){ if(e.key === 'Escape') close(); });
  document.addEventListener('keydown',function(e){
    if(e.key === 'Escape' && nav.classList.contains('open')) close();
  });
}

/* ── Wishlist toggle ────────────────────────────────────────── */
function initWishlist(){
  document.addEventListener('click',function(e){
    var btn = e.target.closest('.pcard-wish');
    if(!btn) return;
    var svg = btn.querySelector('svg');
    var on  = btn.dataset.on === '1';
    if(svg) svg.setAttribute('fill', on ? 'none' : 'currentColor');
    btn.dataset.on = on ? '0' : '1';
    btn.setAttribute('aria-label', on ? 'Add to wishlist' : 'Remove from wishlist');
    btn.setAttribute('aria-pressed', (!on).toString());
  });
}

/* ── Sticky ATC ─────────────────────────────────────────────── */
function initStickyATC(){
  var mainATC   = qs('.atc-btn');
  var stickyBar = qs('.sticky-atc');
  if(!mainATC || !stickyBar) return;

  var stickyBtn = qs('.sticky-atc-btn');
  if(stickyBtn){
    // Copy variant ID from first active var-btn
    var firstVar = qs('.var-btn.on');
    if(firstVar) stickyBtn.dataset.variant = firstVar.dataset.variant;

    stickyBtn.addEventListener('click',function(){
      var vid = stickyBtn.dataset.variant || (qs('[name="id"]') ? qs('[name="id"]').value : '');
      if(vid) addToCart(vid, 1, stickyBtn);
    });
  }

  // Show sticky bar when main ATC scrolls out of view
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        stickyBar.classList.remove('visible');
      } else {
        stickyBar.classList.add('visible');
      }
    });
  }, { threshold:0.1, rootMargin:'0px 0px -60px 0px' });

  observer.observe(mainATC);
}

/* ── Cart page AJAX qty ─────────────────────────────────────── */
function initCartPage(){
  document.addEventListener('click',function(e){
    var btn = e.target.closest('.js-qty');
    if(!btn) return;
    var line  = btn.dataset.line;
    var delta = parseInt(btn.dataset.delta, 10);
    var ctrl  = btn.closest('.qty-ctrl');
    var valEl = ctrl ? ctrl.querySelector('.qty-val') : null;
    var cur   = valEl ? (parseInt(valEl.textContent, 10) || 1) : 1;
    var next  = Math.max(0, cur + delta);

    btn.disabled = true;
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line, quantity:next})
    })
    .then(function(r){return r.json();})
    .then(function(){ window.location.reload(); })
    .catch(function(){ btn.disabled = false; });
  });
}

/* ── Escape closes cart ─────────────────────────────────────── */
function initEscapeKey(){
  document.addEventListener('keydown',function(e){
    if(e.key !== 'Escape') return;
    var drawer = qs('#cart-drawer');
    if(drawer && drawer.classList.contains('open')) closeCart();
  });
}

/* ── Announce cart changes to screen readers ────────────────── */
function announceToSR(msg){
  var live = qs('#cart-live');
  if(!live){ live = document.createElement('div'); live.id='cart-live'; live.setAttribute('role','status'); live.setAttribute('aria-live','polite'); live.className='sr-only'; document.body.appendChild(live); }
  live.textContent = '';
  setTimeout(function(){ live.textContent = msg; }, 100);
}

/* ── Image lazy loading polyfill (Safari<16) ────────────────── */
function initLazyImages(){
  if('loading' in HTMLImageElement.prototype) return; // native support
  var images = qsa('img[loading="lazy"]');
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        var img = entry.target;
        if(img.dataset.src){ img.src = img.dataset.src; }
        io.unobserve(img);
      }
    });
  });
  images.forEach(function(img){ io.observe(img); });
}

/* ── Smooth scroll anchor links ─────────────────────────────── */
function initSmoothScroll(){
  document.addEventListener('click',function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var id = a.getAttribute('href');
    var target = qs(id);
    if(!target) return;
    e.preventDefault();
    target.scrollIntoView({behavior:'smooth', block:'start'});
    target.setAttribute('tabindex','-1');
    target.focus({preventScroll:true});
  });
}

/* ── Init ───────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){

  /* Cart triggers */
  qsa('.js-cart-open').forEach(function(el){
    el.addEventListener('click',function(e){ e.preventDefault(); openCart(el); });
  });
  var closeCartBtn = qs('#cart-close');
  if(closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  var overlay = qs('#cart-overlay');
  if(overlay) overlay.addEventListener('click', closeCart);

  /* Initial cart count */
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    qsa('.cart-count-badge').forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }).catch(function(){});

  initAccordions();
  initGallery();
  initVariants();
  initForms();
  initQuickAdd();
  initMobileNav();
  initWishlist();
  initStickyATC();
  initCartPage();
  initEscapeKey();
  initLazyImages();
  initSmoothScroll();
});

})();
